import { Link } from "wouter";
import { FONT, PRODUCT_NAME, SAGE, WARM } from "@shared/brand";

/**
 * Minimal branded header for the auth pages (login / signup), added s90 for demo prep.
 * Tree-mark + wordmark (matches the landing-page nav and favicon) linking back to `/`
 * (the landing page for unauthenticated visitors). No header bar — sits on the cream bg.
 */
export function AuthBrandHeader() {
  return (
    <div className="flex justify-center mb-6">
      <Link href="/">
        <span
          className="flex items-center gap-2.5 cursor-pointer"
          data-testid="link-auth-home"
        >
          <svg width="38" height="38" viewBox="0 0 64 64" fill="none" aria-hidden="true" style={{ flex: "none" }}>
            <circle cx="32" cy="32" r="24" stroke={SAGE[600]} strokeWidth="3" />
            <path d="M32 46V24" stroke={SAGE[600]} strokeWidth="3" strokeLinecap="round" />
            <path d="M32 30l-7-5.5M32 30l7-5.5M32 38l-6-4.5M32 38l6-4.5" stroke={SAGE[600]} strokeWidth="3" strokeLinecap="round" />
          </svg>
          <span style={{ fontFamily: FONT.serif, fontWeight: 500, fontSize: 24, color: WARM.ink }}>
            {PRODUCT_NAME}
          </span>
        </span>
      </Link>
    </div>
  );
}
